/**
 * @generated SignedSource<<60525403887e4dfb0f04abfdd7cf9e49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbSharedItemTrackingProvider_itemSearch$data = {
  readonly pageType: string | null;
  readonly searchTerm: string | null;
  readonly displayUriRef: string | null;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly item: {
        readonly serviceId: string | null;
        readonly title: string | null;
        readonly categoryPath: string | null;
        readonly browseUrl: string | null;
        readonly categoryCode: string | null;
        readonly contemporaryTrackingString: string;
        readonly seller: {
          readonly serviceId: string | null;
        } | null;
        readonly displayPriceTracking: ReadonlyArray<{
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
          readonly amountType: string | null;
          readonly textType: string | null;
        } | null> | null;
        readonly isAuctionEnabled: boolean | null;
        readonly " $fragmentSpreads": FragmentRefs<"freeShippingHelpers_item">;
      } | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "SbSharedItemTrackingProvider_itemSearch";
};
export type SbSharedItemTrackingProvider_itemSearch$key = {
  readonly " $data"?: SbSharedItemTrackingProvider_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedItemTrackingProvider_itemSearch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedItemTrackingProvider_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchTerm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryPath",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "browseUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contemporaryTrackingString",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Seller",
                  "kind": "LinkedField",
                  "name": "seller",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": "displayPriceTracking",
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "isTrade",
                      "variableName": "isTrade"
                    },
                    {
                      "kind": "Literal",
                      "name": "page",
                      "value": "searchAndBrowse"
                    }
                  ],
                  "concreteType": "ItemDisplayPriceType",
                  "kind": "LinkedField",
                  "name": "displayPrice",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConvertedAmountList",
                      "kind": "LinkedField",
                      "name": "convertedAmountList",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currency",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "amountType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "textType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAuctionEnabled",
                  "storageKey": null
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "freeShippingHelpers_item",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vertical",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ShipmentQuote",
                      "kind": "LinkedField",
                      "name": "shipmentQuotes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isComplimentary",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "kind": "LinkedField",
                          "name": "totalAmount",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ShipmentServiceMethod",
                          "kind": "LinkedField",
                          "name": "serviceMethod",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Region",
                              "kind": "LinkedField",
                              "name": "region",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "regionName",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "964baffbb38d4601c3e610cc847eebc0";

export default node;
